import { isNotNil } from '@flowio/is';
import getStyle from './getStyle';
import isDocument from './isDocument';
import isHTMLElement from './isHTMLElement';
import isSVGSVGElement from './isSVGSVGElement';
import isWindow from './isWindow';
/**
 * Get the current computed outer width for the specified element, including
 * padding and border.
 *
 * If the `window` object is provided, returns the width of the browser window
 * viewport including, if rendered, the vertical scrollbar width.
 *
 * If the `document` object is provided, returns the width of the rendered
 * document including content not visible in the browser window viewport.
 *
 * @param element The element to return the information for.
 * @param includeMargin A `Boolean` indicating whether to include the
 * element's margin in the calculation.
 */

export default function getOuterWidth(element) {
  var includeMargin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (isWindow(element)) {
    // The width (in pixels) of the browser window viewport including,
    // if rendered, the horizontal scrollbar.
    return element.innerWidth;
  }

  if (isDocument(element)) {
    // Either scrollWidth or offsetWidth or clientWidth,
    // whichever is greatest.
    return Math.max(element.body.scrollWidth, element.documentElement.scrollWidth, element.body.offsetWidth, element.documentElement.offsetWidth, element.documentElement.clientWidth);
  }

  var outerWidth = 0;

  if (isHTMLElement(element)) {
    outerWidth = element.offsetWidth;
  } else if (isSVGSVGElement(element)) {
    outerWidth = element.getBBox().width;
  }

  if (includeMargin) {
    var marginLeft = getStyle(element, 'marginLeft');
    var marginRight = getStyle(element, 'marginRight');
    return outerWidth + (isNotNil(marginLeft) ? parseInt(marginLeft, 10) : 0) + (isNotNil(marginRight) ? parseInt(marginRight, 10) : 0);
  }

  return outerWidth;
}
//# sourceMappingURL=getOuterWidth.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/blaze-consumer/~/@flowio/browser-helpers/lib/esm/getOuterWidth.js
// module id = 472
// module chunks = 0 1